import landingIndustryLeadingLayer1 from "./images/landing-industry-leading-layer-1.png";
import landingIndustryLeadingLayer2 from "./images/landing-industry-leading-layer-2.png";
import landingIndustryLeadingRack from "./images/landing-industry-leading-rack.png";
import landingIndustryLeadingLayer4 from "./images/landing-industry-leading-layer-4.png";
import landingIndustryLeadingLayer5 from "./images/landing-industry-leading-layer-5.png";

export default {
  v: "5.12.1",
  fr: 30,
  ip: 0,
  op: 140,
  w: 1460,
  h: 720,
  nm: "Brand-Slide-1b-full-size",
  ddd: 0,
  assets: [
    {
      id: "image_0",
      w: 1385,
      h: 1302,
      u: "",
      p: landingIndustryLeadingLayer1,
      e: 0,
    },
    {
      id: "image_1",
      w: 683,
      h: 669,
      u: "",
      p: landingIndustryLeadingLayer2,
      e: 0,
    },
    {
      id: "image_2",
      w: 862,
      h: 1438,
      u: "",
      p: landingIndustryLeadingRack,
      e: 0,
    },
    {
      id: "image_3",
      w: 743,
      h: 1092,
      u: "",
      p: landingIndustryLeadingLayer4,
      e: 0,
    },
    {
      id: "image_4",
      w: 691,
      h: 1286,
      u: "",
      p: landingIndustryLeadingLayer5,
      e: 0,
    },
  ],
  layers: [
    {
      ddd: 0,
      ind: 1,
      ty: 3,
      nm: "pos-4",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [735, 372, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 2,
      ty: 3,
      nm: "pos-3",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [727, 352, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 3,
      ty: 3,
      nm: "pos-2",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [735, 369, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 4,
      ty: 3,
      nm: "pos-1",
      sr: 1,
      ks: {
        o: { a: 0, k: 0, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 20,
              s: [730, 360, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 80,
              s: [725, 373, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 140, s: [730, 360, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 5,
      ty: 2,
      nm: "layer-1.png",
      cl: "png",
      parent: 4,
      refId: "image_0",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [407.5, -48, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [396.5, -8, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [692.5, 651, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [40, 40, 100],
            },
            { t: 20, s: [49, 49, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 6,
      ty: 2,
      nm: "layer-2.png",
      cl: "png",
      parent: 3,
      refId: "image_1",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [531.5, 84.5, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [551.5, 64.5, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [341.5, 334.5, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [60, 60, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 7,
      ty: 4,
      nm: "mask",
      td: 1,
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: { a: 0, k: [1154, 325, 0], ix: 2, l: 2 },
        a: { a: 0, k: [0, 0, 0], ix: 1, l: 2 },
        s: { a: 0, k: [100, 100, 100], ix: 6, l: 2 },
      },
      ao: 0,
      shapes: [
        {
          ty: "gr",
          it: [
            {
              ty: "rc",
              d: 1,
              s: { a: 0, k: [482, 650], ix: 2 },
              p: { a: 0, k: [0, 0], ix: 3 },
              r: { a: 0, k: 0, ix: 4 },
              nm: "Rectangle Path 1",
              mn: "ADBE Vector Shape - Rect",
              hd: false,
            },
            {
              ty: "fl",
              c: { a: 0, k: [0, 0, 0, 1], ix: 4 },
              o: { a: 0, k: 100, ix: 5 },
              r: 1,
              bm: 0,
              nm: "Fill 1",
              mn: "ADBE Vector Graphic - Fill",
              hd: false,
            },
            {
              ty: "tr",
              p: { a: 0, k: [0, 0], ix: 2 },
              a: { a: 0, k: [0, 0], ix: 1 },
              s: { a: 0, k: [100, 100], ix: 3 },
              r: { a: 0, k: 0, ix: 6 },
              o: { a: 0, k: 100, ix: 7 },
              sk: { a: 0, k: 0, ix: 4 },
              sa: { a: 0, k: 0, ix: 5 },
              nm: "Transform",
            },
          ],
          nm: "Rectangle 148809",
          np: 2,
          cix: 2,
          bm: 0,
          ix: 1,
          mn: "ADBE Vector Group",
          hd: false,
        },
      ],
      ip: 0,
      op: 150,
      st: 0,
      ct: 1,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 8,
      ty: 2,
      nm: "rack.png",
      cl: "png",
      tt: 1,
      tp: 7,
      refId: "image_2",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [1164.5, 385.5, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [1164.5, 360.5, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [431, 719, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [44, 44, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 9,
      ty: 2,
      nm: "layer-4.png",
      cl: "png",
      parent: 2,
      refId: "image_3",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [173.5, -46.5, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [73.5, -76.5, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [371.5, 546, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [40, 40, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
    {
      ddd: 0,
      ind: 10,
      ty: 2,
      nm: "layer-5.png",
      cl: "png",
      parent: 1,
      refId: "image_4",
      sr: 1,
      ks: {
        o: { a: 0, k: 100, ix: 11 },
        r: { a: 0, k: 0, ix: 10 },
        p: {
          a: 1,
          k: [
            {
              i: { x: 0.667, y: 1 },
              o: { x: 0.333, y: 0 },
              t: 0,
              s: [109.5, -18.5, 0],
              to: [0, 0, 0],
              ti: [0, 0, 0],
            },
            { t: 20, s: [19.5, -38.5, 0] },
          ],
          ix: 2,
          l: 2,
        },
        a: { a: 0, k: [345.5, 643, 0], ix: 1, l: 2 },
        s: {
          a: 1,
          k: [
            {
              i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] },
              o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] },
              t: 0,
              s: [37, 37, 100],
            },
            { t: 20, s: [50, 50, 100] },
          ],
          ix: 6,
          l: 2,
        },
      },
      ao: 0,
      ip: 0,
      op: 150,
      st: 0,
      bm: 0,
    },
  ],
  markers: [
    { tm: 20, cm: "1", dr: 0 },
    { tm: 140, cm: "2", dr: 0 },
  ],
  props: {},
};
